module.exports = __webpack_public_path__ + "img/Society.46528920.png";